import NewsList from "../Views/News/NewsList.vue";
import NewsCreate from "../Views/News/NewsCreate.vue";
import NewsEdit from "../Views/News/NewsEdit.vue";
import NewsShow from "../Views/News/NewsShow.vue";
import { MODULES } from "../Constants/modules.js";
import { adminGuard } from "./guards.js";

export const newsRoutes = [
    {
        path: "/news/edit/:id",
        name: "news.edit",
        component: NewsEdit,
        beforeEnter: adminGuard,
        meta: {
                module: MODULES.NEWS,
            menu: {
                parent: 'news',
                child: 'news'
            },
            breadcrumb: {
                title: "Actualités",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Toutes les actualités",
                            link: {name: 'news.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/news/create",
        name: "news.create",
        component: NewsCreate,
        beforeEnter: adminGuard,
        meta: {
                module: MODULES.NEWS,
            menu: {
                parent: 'news',
                child: 'news'
            },
            breadcrumb: {
                title: "Actualités",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Toutes les actualités",
                            link: {name: 'news.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/news/:id",
        name: "news.show",
        component: NewsShow,
        meta: {
                module: MODULES.NEWS,
            menu: {
                parent: 'news',
                child: 'news'
            },
            breadcrumb: {
                title: "Actualités",
                nav: {
                    all: {
                        active: "Fiche utilisateur",
                        inactive: [{
                            title: "Toutes les actualités",
                            link: {name: 'news.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/news",
        name: "news.list",
        component: NewsList,
        meta: {
                module: MODULES.NEWS,
            menu: {
                parent: 'news',
                child: 'news'
            },
            breadcrumb: {
                title: "Actualités",
                nav: {
                    all: {
                        active: "Toutes les actualités",
                        inactive: []
                    }
                }
            }
        },
    }
];
